import React, { FC } from 'react';
import i18n from '~/i18n';
import { Amount } from '~/types';
import { Longdash } from '~/utils';
import { languagesConfig } from '~/utils/i18n';

interface Props {
  amount: Amount | undefined;
  className?: string;
  abs?: boolean;
}

const AmountField: FC<Props> = (props) => {
  const { amount, className, abs } = props;
  return (
    <div className={className} style={{ whiteSpace: 'nowrap' }}>
      {getAmountText(amount, abs)}
    </div>
  );
};

export const getAmountText = (amount?: Amount, abs?: boolean, language?: string): string => {
  let amountText: string = Longdash;
  const currentLanguage = language || i18n.language;

  if (!amount || (amount.value !== 0 && !amount.value) || !amount.currency) {
    amountText = Longdash;
  } else {
    const value = abs ? Math.abs(amount.value) : amount.value;
    amountText = value.toLocaleString(languagesConfig[currentLanguage].numberIntlLocale || 'en', {
      style: 'currency',
      currency: amount.currency,
    });
  }
  return amountText;
};

export default AmountField;
